import { FC, ReactNode } from "react";
import { Box, Divider, alpha, lighten, useTheme } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Logo from "../../shared/logo/metaDeskLogo.svg";
import Footer from "./Footer";
interface SidebarLayoutProps {
  children?: ReactNode;
}
const SidebarLayout: FC<SidebarLayoutProps> = () => {
  const theme = useTheme();
  const location = useLocation();
  const isDashboard = location.pathname.includes("dashboard");

  return (
    <>
      <Box
        className="main-layout-container"
        sx={{
          flex: 1,
          height: "100%",

          ".MuiPageTitle-wrapper": {
            background:
              theme.palette.mode === "dark"
                ? theme.colors.alpha.trueWhite[5]
                : theme.colors.alpha.white[50],
            marginBottom: `${theme.spacing(4)}`,
            boxShadow:
              theme.palette.mode === "dark"
                ? `0 1px 0 ${alpha(
                    lighten(theme.colors.primary.main, 0.7),
                    0.15,
                  )}, 0px 2px 4px -3px rgba(0, 0, 0, 0.2), 0px 5px 12px -4px rgba(0, 0, 0, .1)`
                : `0px 2px 4px -3px ${alpha(
                    theme.colors.alpha.black[100],
                    0.1,
                  )}, 0px 5px 12px -4px ${alpha(
                    theme.colors.alpha.black[100],
                    0.05,
                  )}`,
          },
        }}
      >
        <Box
          className="content-area"
          sx={{
            position: "relative",
            display: "block",
            flex: 1,
            // [theme.breakpoints.up("lg")]: {
            //   ml: isDashboard ? 0 : `${theme.sidebar.width}`,
            // },
          }}
        >
          {/* <Box display="block" className="somethimng"> */}
          <Header />
          {/* </Box> */}
        </Box>
        {!isDashboard && <Sidebar />}
        <Box
          sx={{
            position: "relative",
            zIndex: 5,
            display: "block",
            flex: 1,
            // pt: `${(theme.header.height as any)/2}`,
            pt: 2,
            pb: 2,
            [theme.breakpoints.up("lg")]: {
              ml: isDashboard ? 0 : `calc(${theme.sidebar.width} + 16px)`,
            },
            "@media (max-width:769px)": {
              marginTop: "80px",
            },
            // [theme.breakpoints.up("lg")]: {
            //   ml: isDashboard ? 0 : `310px`,
            // },
          }}
        >
          <Box display="block" sx={{ maxHeight: "95vh", overflowY: "scroll" }}>
            <Outlet />
          </Box>
          {/* <Box sx={{ paddingTop: 5 }}>
            <Footer />
          </Box> */}
        </Box>
      </Box>
    </>
  );
};

export default SidebarLayout;
